export const formatAddress = (walletAddress = '') => walletAddress?.slice(0, 9) + '...' + walletAddress?.slice(-4);